import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { AssetContainer } from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/styledComponents";

export const Wrapper = styled(AssetContainer)`
    --button-background: ${colorsPalettes.blue[100]};
    --text-color: ${colorsPalettes.midnight[100]};
    --icon-fill: ${colorsPalettes.carbon[200]};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${colorsPalettes.bluegrey[100]};

    &:hover {
        --button-background: ${colorsPalettes.blue[200]};
        --text-color: ${colorsPalettes.blue[400]};
        --icon-fill: ${colorsPalettes.blue[400]};
    }
`;

export const IconButtonWrapper = styled.div`
    & > button {
        background-color: var(--button-background);
        pointer-events: none;

        & svg > path {
            fill-opacity: 1;
            fill: var(--icon-fill) !important;
            transition: 0.2s;
        }
    }
`;

export const Text = styled.p`
    margin: 12px 0 0;
    color: var(--text-color);
    ${setFontVariant("button")};
    transition: 0.2s;
`;
